
export class MetaProcessLog {
businessUnitCode: string;
createTime: number | null;
domain: string;
id: number | null;
log: Object;
processCode: string;
processUuid: string;
visionCode: string;
}

